import React, {Component} from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthConsumer } from "../context/AuthContext";

class ProtectedRoute extends Component {

    render() {
 		const { component: Component, ...more } = this.props;  
 		return (
 			<Route {...more} render={(props) =>
		 		<AuthConsumer>
		 		 {({ authenticated }) => 
			        authenticated ? 
		               (  <Component {...props} {...more} /> )
		        	:
		               (  (<Redirect to={{ pathname: '/' }} />) )
			    }
		 		</AuthConsumer>
		 	}/>
		)
    }
}

export default ProtectedRoute;